import { useCallback, useEffect } from 'react';

import { deleteCookie, getEnvVars } from '@order/utils';

import { useHasLoggedOut } from '../../context/AuthMachine';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * A hook that resets Sierra on logout by clearing its cookie.
 */
export const useResetSierraOnLogout = () => {
  const hasLoggedOut = useHasLoggedOut();

  const resetSierra = useCallback(async () => {
    await deleteCookie(SIERRA_CHAT_SESSION, SIERRA_CHAT_URL);
  }, []);

  useEffect(() => {
    if (hasLoggedOut) void resetSierra();
  }, [hasLoggedOut, resetSierra]);
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SIERRA_CHAT_SESSION = 'sierra-chat-session';
const SIERRA_CHAT_URL: string = getEnvVars()
  .SIERRA_EMBEDDED_CHATBOT_URL as string;
